import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {finalize, take} from 'rxjs/operators';
import {ContentPage} from '../../page.interface';
import {DataService} from '../../services/data/data.service';
import {Utils} from '../../utils/utils.class';
import { Detail, DetailsConfig } from './interfaces/details-config.interface';
import {MapOfStringTo} from '../../interfaces/map-of-string-to.type';
import {MapsService} from "../../services/maps.service";
import { ProcessAction } from '../../interfaces/process-action.interface';

@Component({
  selector: 'sellions-layout-renderer-details',
  templateUrl: './details.component.html',
})
export class DetailsComponent implements OnInit {
  @Input() detailsScreenConfig: DetailsConfig; // screensy, na podstawie których definiowane jest jakie zmienne z listy są do pobrania
  @Input() screenData: MapOfStringTo<any>; // lista na podstawie której pobierane są odpowiednie zmienne.
  @Input() database: any;
  @Input() baseUrl: string;
  @Input() params: any;
  @Output() elementClicked = new EventEmitter<{
    element: Object;
    target: EventTarget;
  }>();
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() dataReloadedEvent = new EventEmitter<MapOfStringTo<any>>();

  constructor(private http: HttpClient, private dataService: DataService, private mapsService: MapsService) {}

  ngOnInit() {
    if (this.detailsScreenConfig && this.detailsScreenConfig.dataSourceConfig) {
      this.reload();
    }
  }

  evaluateValueByKeyName(variableNameToBind: string): string {
    return Utils.evaluateString(variableNameToBind, this.screenData);
  }

  onClick(element: any, $event: MouseEvent) {
    if(element['type'] && element.type === 'button' && element['buttonProcessAction']) {
      this.elementClicked.emit({element: {
        process: {
          processKey: element.buttonProcessAction.processKey,
          formMapping: element.buttonProcessAction.formMapping,
          formMappingFromParentObject: element.buttonProcessAction.formMappingFromParentObject,
          referenceMapping: element.buttonProcessAction.referenceMapping
        },
        element: this.screenData
      } as ProcessAction, target: $event.target });
    } else {
      this.elementClicked.emit({ element, target: $event.target });
    }
  }

  reload(): void {
    if (!this.baseUrl) {
      throw new Error('The baseUrl cannot be null or empty');
    }

    this.changeLoadingStatus(true);

    const url = this.getDataUrl();
    if (url) {
      this.http
        .get<ContentPage>(url)
        .pipe(take(1))
        .pipe(
          finalize(() => {
            this.changeLoadingStatus(false);
          }),
        )
        .subscribe(
          (data) => {
            this.screenData = {...this.screenData, ...data};
            this.dataReloadedEvent.emit(this.screenData);
          },
          (error) => console.error(error),
        );
    }
  }

  private changeLoadingStatus(status: boolean): void {
    this.loadingEvent.emit(status);
  }

  getItemConditionsEvaluation(item) {
    if (item.displayConditions) {
      return this.screenData[item.displayConditions];
    } else {
      return true;
    }
  }

  evaluateVisibilityCondition(itemConfig: Detail) {
    return Utils.evaluateVisibilityCondition(itemConfig.visibilityCondition, this.screenData);
  }

  private getDataUrl(): string {
    let url = this.dataService.getUrl(this.baseUrl, this.detailsScreenConfig.dataSourceConfig.onlineDataSourceUrl);
    url = Utils.evaluateVariablesString(url, this.params);
    return url;
  }

  getDirections(locationPropertyName: string | string[]): void {
    const mapLink = this.getDirectionsLink(locationPropertyName);
    window.open(mapLink, '_blank');
  }

  private getDirectionsLink(locationPropertyName: string | string[]): string {
    let locationObject =  {lat: null, lon: null};
    locationObject = this.getLocationObject(locationPropertyName);
    const lat = locationObject.lat;
    const lon = locationObject.lon;
    return this.mapsService.getDirectionsLink(lat, lon);
  }

  private getLocationObject(locationPropertyName: string | string[]) {
    if (Array.isArray(locationPropertyName)) {
      return locationPropertyName.reduce(function(obj, prop) {
        return obj && obj[prop];
      }, this.screenData);
    } else {
      return this.screenData[locationPropertyName];
    }
  }

  getScreenData(): MapOfStringTo<any> {
    return this.screenData;
  }


  checkIfLocalizationDataExists(property: string | string[]) {
    return this.getLocationObject(property);
  }

  getDataValue(field: any) {
    if (typeof field === 'string') {
      return this.screenData[field];
    } else if (Array.isArray(field)) {
      return field.reduce(function(obj, prop) {
        return obj && obj[prop];
      }, this.screenData);
    }
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/details/details.component.ts